import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { GetFilingInstancePrimaryEntityRecords } from '../../store/actions/gst-filing.actions';
import { getFilingPrimaryEntityRecords$, getFilingSelectedAppMetaData$ } from '../../store/selectors/gst-filing.selector';
import { Record } from '../../models/record/record.class';

@Component({
    selector: 'app-instance-data-primary-entity',
    templateUrl: './instance-data-primary-entity.component.html',
    styleUrls: ['./instance-data-primary-entity.component.scss'],
    standalone: false,
})
export class InstanceDataPrimaryEntityComponent implements OnInit, OnDestroy {
    public showBtnContent = 'Show More';
    public primaryEntity: any;
    private unSubscribe = new Subject();
    public record: Record;

    constructor(private store$: Store, private renderer: Renderer2) {}

    private initiateSubscriptions = () => {
        this.store$
            .select(getFilingSelectedAppMetaData$)
            .pipe(
                takeUntil(this.unSubscribe),
                filter(data => data?.templateUpdated)
            )
            .subscribe(metaData => {
                this.primaryEntity = metaData?.entities?.find(entity => entity.primary);
            });
        this.store$
            .select(getFilingPrimaryEntityRecords$)
            .pipe(takeUntil(this.unSubscribe))
            .subscribe((records: Record[]) => {
                this.record = new Record(records?.[0], this.primaryEntity);
            });
    };

    moreOrLessEntityData = (isOutsideClick: boolean) => {
        const element = document.querySelector('.nonBusinessKeys') as HTMLElement;
        if (this.showBtnContent === 'Show More' && !isOutsideClick) {
            if (element) {
                this.renderer.setStyle(element, 'display', 'block');
            }
            this.showBtnContent = 'Show Less';
        } else {
            if (element) {
                this.renderer.setStyle(element, 'display', 'none');
            }
            this.showBtnContent = 'Show More';
        }
    };

    getFieldByFieldId = (fieldId): string => {
        const field = this.record?.fields.find(field => field.id === fieldId);
        return field?.value as string;
    };

    ngOnInit(): void {
        this.initiateSubscriptions();
        this.store$.dispatch(GetFilingInstancePrimaryEntityRecords());
    }

    ngOnDestroy(): void {
        this.unSubscribe.next(undefined);
        this.unSubscribe.complete();
    }
}
